
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconMinorStake as ObiBeaconMinorStakeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-minor-stake.js';
 
 
 

 
 export const ObiBeaconMinorStake = createComponent({
   react: React,
   tagName: 'obi-beacon-minor-stake',
   elementClass: ObiBeaconMinorStakeElement,
   events: {
     
   }
  });
 
 